import { ajaxGet } from "rxjs/internal/observable/dom/AjaxObservable";
import Constants from "utils/Constants";
import { map } from "rxjs/operators";
import { useSelector } from "react-redux";
import AppState from "state/AppState";
import { BetaModuleUserIds } from "commonUse/useJoinInternalTest";
/**
 * 所有字段可空,和redux中的DeepPartial区别是数组的处理上
 */

type Activity = {
    // APP 活动[可选]
    app: {
        // 活动APP封面图
        image: string;
        // 活动外链[可选]
        link: string;
        // 外链打开方式[可选]
        linkType: "webview" | "browser";
        // APP 内部路由
        app: string;
    };
    // web活动[可选]
    web: {
        // 活动封面图
        image: string;
        // 活动链接[可选]
        link: string;
    };
};

type ACHFee = {
    // 默认费率
    default: string;
    // 活动费率[可选]
    activity: string;
    /** 用于文案显示的字段 **/
    // 默认费率
    default_display: string;
    // 活动费率[可选]
    activity_display?: string;
};

export type DWConfig = {
    d: {
        cir_card: {
            limit: {
                min: number;
                max: number;
                tip: string;
            };
        };
        cir_ach: {
            fee: ACHFee;
            // 通道活动配置 [可选]
            activity: Activity;
            // 单笔限额
            limit: {
                min: number;
                max: number;
            };
            // 用户信用等级对应的限制文案
            userLevel: Record<number, { r10dLimitTip: string }>;
        };
        stripe_ach: {
            limit: {
                min: number,
                max: number
            },
            userLevel: {
                [key: number]: {
                    [key: string]: string
                }
            },
            limitGroup: {
                [key: number]: {
                    min: number;
                    max: number;
                    frequency_max: number;
                }
            }
        }
    };
    w: {
        wire: {
            fee: number;
            min: number;
            limit: { tip: string };
        };
        cir_ach: {
            fee: ACHFee;
            activity: Activity;
        };
    };
};

export type TradeConfig = {
    bots: {
        martingale: {
            aviQuotes: string[];
        };
        grid: {
            gridUnLimitPairs: string[];
        };
    };
};

export type FeesConfigExtraItem = { base: string; fee: "0%"; symbols: string[] };

export type FeesConfig = {
    spot: {
        type: string;
        taker: number;
        maker: number;
        ac_taker: number;
        ac_maker: number;
        extra: Array<FeesConfigExtraItem>;
    };
};

export type learnCallType = {
    baRequired: number;
    app: {
        title: string;
        content: string;
        tip: string;
    };
    web: {
        title: string;
        content: string;
        tip: string;
        link: string;
    };
};

export enum DebitErrorType {
    CHANNEL_CLOSED = "CHANNEL_CLOSED",
    CIRCLE_CARD_DUPLICATE_BIND = "CIRCLE_CARD_DUPLICATE_BIND",
    CIRCLE_KYC_NOT_PASSED = "CIRCLE_KYC_NOT_PASSED",
    DEFAULT = "DEFAULT",
    PAYMENT_CHANNEL_MAINTENANCE = "PAYMENT_CHANNEL_MAINTENANCE",
    UPSTREAM_ERROR = "UPSTREAM_ERROR",
}

export type ErrorMapType = {
    debit_card_failure: {
        [key in DebitErrorType]: string;
    };
    wire_withdraw_failure: {
        INCORRECT_WITHDRAW_INFO: "We could not locate the beneficiary name or account you submitted, please check the account details or try another one.";
        ACCOUNT_UNSUPPORT_WIRE: "We tried to remit your funds, but the Beneficiary account doesn't accept Wire Transfers. Please replace it with an account supports wire.";
    };
};

export type ShareMapType = {
    bot: {
        win: {
            // 胜利方向
            bg: ""; // 背景图
            bgColor: ""; // 默认背景颜色
            styles: {
                ha: {}; // 顶部小字样式
                hb: {}; // 顶部二级大字样式
                gt: {}; // 收益栅格标题样式
                gc: {}; // 收益栅格内容样式
            };
        };
        loss: {
            // 损失方向
            bg: "";
            bgColor: ""; // 默认背景颜色
            styles: {
                ha: {};
                hb: {};
                gt: {};
                gc: {};
            };
        };
    };
};

/**
 * ⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️
 * 请注意：定义配置字段全部定义为可选字段，避免出现配置失效导致的系统崩溃或报错。
 * ⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️
 */
export type OnlineConfigData = DeepPartial<{
    dw: DWConfig;
    trade: TradeConfig;

    fees: FeesConfig;
    learnCall: learnCallType;
    errorMap: ErrorMapType;
    share: ShareMapType;
    taxes: GlobalConfig_Taxes;
    betaTestData: BetaModuleUserIds;
    buyCrypto: {
        _: {
            shortAmounts: string[];
        };
    };
}>;

export const TYPE_REFRESH_ONLINE_CONFIG = "type_refresh_online_config";

export interface GlobalConfig_Taxes {
    headerImage_app: string;
    headerImage_web: string;
    availableTimestamp: number; // 新用户判断是否
    taxesYear: number; // 需要报税的年份
    freeAmount: number; //（单位：美元）tax service free amount
    features: {
        title: string;
        icon: string; // 图标在线 url 地址
        desc?: string;
    }[];
    shareModal: {
        titleSuccess: string;
        titleShare: string;
        titleQuit: string;
        titleNewUser: string;
        titleVipLimited: string;
        items: {
            title: string;
            icon: string; // 图标在线 url 地址
        }[];
    };
}
// example
// {
//   taxes: {
//     availableTimestamp: string; // 在这个时间后注册的用户，则不能使用报税功能，毫秒级别。目前的 2022 应该设置为 new Date(‘2022-12-31 23:59:59’).getTime();==> ‘1672502399000’
//     taxesYear: 2022, // 需要报税的年份
//     freeAmount: 1000, // （美元）tax service free amount
//     tips: [{
//       title: “Easy. Form 8949 auto-generated”,
//       desc: “For reference only”,
//       icon: ‘http:xxx.png’,
//     }, {
//       title: “Fast. Complete in 1 minute”,
//       icon: ‘http:xxx.png’,
//     }, {
//       title: “1 on 1 consultation service for VIP users”,
//       icon: ‘http:xxx.png’,
//     }]
//   }
// }

export class OnlineConfig {
    static refresh() {
        ajaxGet(`${Constants.configHost}/global_config.json`, { "Cache-Control": "no-cache" })
            .pipe(map((res) => res.response))
            .subscribe((res) => {
                AppState.store.dispatch({ type: TYPE_REFRESH_ONLINE_CONFIG, data: res });
            });
    }

    static init() {
        this.refresh();
    }

    static reducer = (state = {}, action) => {
        switch (action.type) {
            case TYPE_REFRESH_ONLINE_CONFIG:
                return action.data;
        }
        return state;
    };
}

export function useOnlineConfig() {
    return useSelector<AppState, OnlineConfigData>((appState) => appState.onlineConfig);
}
